import * as React from "react";
import {Fragment} from "react";
import {Option, option} from "ts-option";
import QuoteItem from "../../../model/quote/QuoteItem";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import QuoteItemList from "./QuoteItemList";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import AddBespokeQuoteItemModal from "../bestspoke/AddBespokeQuoteItemModal";
import AssetCategory from "../../../model/asset/AssetCategory";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import AssetSearch from "../../../model/asset/AssetSearch";
import AssetSelectionComponent from "../../job/billOfMaterials/details/AssetSelectionComponent";

interface ComponentProps {
	/**
	 * VAT registered
	 */
	vatRegistered: boolean;
	/**
	 * Vat
	 */
	vat: number
	/**
	 * Partner brand identifier
	 */
	partnerBrandId: Option<string>,
	/**
	 * Brand identifier
	 */
	brandId: string
	/**
	 * Custom parts markup
	 */
	bespokeItemMarkup: number
	/**
	 * Parts Price strategy
	 */
	partsPriceStrategy: string
}

interface ReduxProps {
	/**
	 * Assets categories
	 */
	assetCategories: AssetCategory[];
}

interface IState {
	/**
	 * Indicator for showing bespoke modal
	 */
	showBespokeModal: boolean;
}

type IComponentProps = FormGroupProps<QuoteItem[]> & ComponentProps;

type Props = IComponentProps & ReduxProps

class QuoteItemFormGroup extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {showBespokeModal: false};
		this.addBespokeItem = this.addBespokeItem.bind(this);
		this.addQuoteItem = this.addQuoteItem.bind(this);
		this.onAddAsset = this.onAddAsset.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Fragment>
				<FormGroup error={this.props.field.firstError().orNull}>
					<div className={"quote-items-container"}>
						<div className={"quote-items-header"}>
							<label className={"m-form-group_label"}>Asset selection</label>
							<ButtonTertiary label={"Add bespoke item"} onClick={() => {this.setState({showBespokeModal: true})}}/>
						</div>
						<AssetSelectionComponent onSelect={this.onAddAsset}
												 excludeIds={this.props.field.getOptionalValue().getOrElse([]).filter(
													 qi => !qi.bespokeItem).map(qi => qi.assetId)}
												 placeholder={"Please select asset"}
												 brandId={this.props.brandId}
												 partnerBrandId={this.props.partnerBrandId.orNull}
												 vatRegistered={this.props.vatRegistered}
												 partsPriceStrategy={this.props.partsPriceStrategy}
						/>
						<QuoteItemList items={this.props.field.getOptionalValue().getOrElse([])}
									   onChange={this.onChange}
									   onRemove={this.onRemove}
									   vat={this.props.vat}/>
					</div>
				</FormGroup>
				{this.state.showBespokeModal &&
				<AddBespokeQuoteItemModal onAdd={this.addBespokeItem}
										  onClose={() => {this.setState({showBespokeModal: false})}}
										  vatRegistered={this.props.vatRegistered}
										  vat={this.props.vat}
										  bespokeItemMarkup={this.props.bespokeItemMarkup}/>}
			</Fragment>

		)
	}

	sortAssetsByCategory(assetsArray: QuoteItem[], assetsOrder: string[]) {
		return assetsArray.sort(function(a: QuoteItem, b: QuoteItem) {
			if (assetsOrder.indexOf(a.categoryId) > assetsOrder.indexOf(b.categoryId)) {
				return 1;
			}
			else if (a.categoryId === b.categoryId) {
				return a.model.localeCompare(b.model);
			}
			else {
				return -1;
			}
		});
	}

	addBespokeItem(item: QuoteItem) {
		this.setState({showBespokeModal: false}, () => this.addQuoteItem(item));
	}

	addQuoteItem(item: QuoteItem) {
		const quoteItems = this.props.field.value.getOrElse([]).concat(item);
		const {assetCategories} = this.props;
		const assetCategoriesIds = assetCategories.map(el => el.id);
		const sortedQuoteItems = this.sortAssetsByCategory(quoteItems, assetCategoriesIds);
		this.props.onChange(this.props.field.updateValue(option(sortedQuoteItems)));
	}

	onAddAsset(asset: AssetSearch) {
		this.addQuoteItem(
			QuoteItem.fromAssetWithQuantity(asset, 1, this.props.vat, this.props.vatRegistered, this.props.partsPriceStrategy));
	}

	onRemove(item: QuoteItem) {
		const quoteItems = this.props.field.value.getOrElse([]).filter(q => q.assetId !== item.assetId);
		this.props.onChange(this.props.field.updateValue(option(quoteItems)));
	}

	onChange(item: QuoteItem) {
		const quoteItems = this.props.field.value.getOrElse([]).map(q => q.assetId == item.assetId ? item : q);
		this.props.onChange(this.props.field.updateValue(option(quoteItems)));
	}
}

function mapStateToProps(state: RootState) {
	const assetCategories = state.assetCategory.assetCategories.getOrElse([]);
	return {
		assetCategories
	}
}

export default connect<ReduxProps, null, IComponentProps>(mapStateToProps)(QuoteItemFormGroup)
